module.exports = __webpack_public_path__ + "static/img/ent-32.a8f0920.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-32.jpg
// module id = S7fL
// module chunks = 52